import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const devRoot = document.querySelector('#stv-v2-landing-root');

if (devRoot) {
  ReactDOM.render(
    <StrictMode>
      <App />
    </StrictMode>,
    devRoot,
  );
}

export default App;
